export const CHECK_PERMISSIONS_LOADING = '[check_permissions]CHECK_PERMISSIONS_LOADING';
export const CHECK_PERMISSIONS_RETAILER = '[check_permissions]CHECK_PERMISSIONS_RETAILER';
export const SET_PERMISSION_STATUS = '[check_permissions]SET_PERMISSION_STATUS';
